import React from 'react'
import './index.less'

/* export default class extends React.Component {
  state = {
    toastStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  hideRule = async (status) => {
    let id = this.props.id

    if (this.state.toastStatus == true) {
      return
    }
    this.setState({
      toastStatus: status
    })
    document.getElementById(`toast${id}`).setAttribute("class", "toast block toastHide")
  }

  render() {
    let { language, lang, id,onHendle,determineHendle } = this.props
    return (
      <div>
        <div id={`toast${id}`} className={`toast hide`} >
          <span className="toastContent">
            'You will no longer receive roomsupport rewards for this room after quit'
          </span>
        </div>
        <div className="btn">
          <div className="noClick" onClick={onHendle}>'No'</div>
          <div className="determine" onClick={determineHendle}>'quit'</div>
        </div>
      </div>
    )
  }
}
 */
export default class extends React.Component {
  state = {
    toastStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }


  hideRule = async (status) => {

    let id = this.props.id


    

    this.setState({
      toastStatus: status
    })

    document.getElementById(`toasts${id}`).setAttribute("class", "toasts block")

    if (status == false) {
      setTimeout(() => {
        this.setState({
          toastStatus: false
        })

        document.getElementById(`toasts${id}`).setAttribute("class", "toasts hide")
      }, 10)
    }
    
  }

  render() {
    let {  lang,  id ,onHendle ,determineHendle} = this.props
    return (
      <div>
      <div id={`toasts${id}`} className={`toasts hide`} >
        <span className="toastContent">
          {lang.deleteRoomTitle}
        </span>
        <div className="btnss">
          <div className="noClick" onClick={onHendle}>{lang.notitle}</div>
          <div className="determine" onClick={determineHendle}>{lang.yes}</div>
        </div>
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/showModal/index.js